'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416 from "./presto.-Dashboard-View$$anon$16.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418 from "./presto.-Dashboard-View$$anon$18.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024 from "./presto.types$-Dashboard-System-Stats$.js";
import * as $j_presto$002etypes$0024$002dSite$002dSystem$0024 from "./presto.types$-Site-System$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$15() {
  this.aJF = null;
  this.aJx = null;
  this.aJy = false;
  this.aJG = null;
  this.aJH = false;
  this.aJK = null;
  this.aJD = null;
  this.aJE = false;
  this.aJz = null;
  this.aJA = false;
  this.aJB = null;
  this.aJC = false;
  this.aJI = false;
  this.aJJ = false;
  this.aJF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJK = "DashboardSystemStats";
}
export { $c_Lpresto_DashboardView$$anon$15 as $c_Lpresto_DashboardView$$anon$15 };
$p = $c_Lpresto_DashboardView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$15;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$15() {
}
export { $h_Lpresto_DashboardView$$anon$15 as $h_Lpresto_DashboardView$$anon$15 };
$h_Lpresto_DashboardView$$anon$15.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aJF;
});
$p.L = (function() {
  if ((!this.aJy)) {
    this.aJx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJy = true;
  }
  return this.aJx;
});
$p.O = (function() {
  if ((!this.aJH)) {
    this.aJG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJH = true;
  }
  return this.aJG;
});
$p.E = (function() {
  return this.aJK;
});
$p.t = (function() {
  if ((!this.aJE)) {
    this.aJD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("system", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aJE = true;
  }
  return this.aJD;
});
$p.M = (function() {
  if ((!this.aJA)) {
    this.aJz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSite$002dSystem$0024.$m_Lpresto_types$SiteSystem$().ig(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416.$c_Lpresto_DashboardView$$anon$16())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aJA = true;
  }
  return this.aJz;
});
$p.Q = (function() {
  if ((!this.aJC)) {
    this.aJB = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418.$c_Lpresto_DashboardView$$anon$18();
    this.aJC = true;
  }
  return this.aJB;
});
$p.w = (function() {
  if ((!this.aJJ)) {
    this.aJI = false;
    this.aJJ = true;
  }
  return this.aJI;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee79) => ((p) => \u03b4scrutinee79.cGy(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024.$m_Lpresto_types$DashboardSystemStats$())));
});
var $d_Lpresto_DashboardView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$15, "presto.DashboardView$$anon$15", ({
  GH: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$15 as $d_Lpresto_DashboardView$$anon$15 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$15.js.map
